import { render, staticRenderFns } from "./Layout-header.vue?vue&type=template&id=48c3579d&scoped=true"
import script from "./Layout-header.vue?vue&type=script&lang=js"
export * from "./Layout-header.vue?vue&type=script&lang=js"
import style0 from "./Layout-header.vue?vue&type=style&index=0&id=48c3579d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c3579d",
  null
  
)

export default component.exports